import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';

@Component({
  selector: 'app-autopilot-devices',
  templateUrl: './autopilot-devices.component.html',
  styleUrls: ['./autopilot-devices.component.scss'],
  imports: [RouterOutlet],
})
export class AutopilotDevicesComponent {}
